import { css, ThemeContext } from '@emotion/react';
import ReactModal from 'react-modal';
import { useContext } from 'react';
import CloseIcon from '@material-ui/icons/Close';

import { AppTheme } from 'theme';

import { Button } from 'components';

type ReactModalAdapterProps = ReactModal['props'] & {
  className?: string;
  modalClassName?: string | ReactModal.Classes;
  showClose?: boolean;
};
const ReactModalAdapter = ({
  className,
  modalClassName,
  showClose,
  children,
  ...props
}: ReactModalAdapterProps) => (
  <ReactModal
    className={modalClassName}
    portalClassName={className}
    closeTimeoutMS={500}
    {...props}
  >
    {children}
    {showClose && (
      <Button
        label={<CloseIcon css={{ verticalAlign: 'top' }} />}
        onClick={props.onRequestClose}
        css={{
          paddingInline: 1,
          paddingBlock: 1,
          position: 'absolute',
          top: 10,
          right: 10,
          width: 'auto',
        }}
        variant="outline-primary"
      />
    )}
  </ReactModal>
);

type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;

type ModalProps = Omit<
  ReactModal['props'],
  'overlayClassName' | 'modalClassName'
> & {
  className?: string;
  showClose?: boolean;
};

const Modal = (props: ModalProps) => {
  const theme = useContext(ThemeContext) as AppTheme;
  const IS_EDU = theme?.layout?.edu;

  return (
    <ReactModalAdapter
      {...props}
      overlayClassName={{
        base: 'Overlay',
        afterOpen: 'Overlay--after-open',
        beforeClose: 'Overlay--before-close',
      }}
      modalClassName="Modal"
      css={css`
        .Modal {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #d8d8d8;
          overflow: auto;
          --webkit-overflow-scrolling: touch;
          outline: none;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
        }

        .Overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: ${IS_EDU
            ? 'rgba(31, 28, 55, 0.85)'
            : 'rgba(0, 0, 0, 0.9)'};
          z-index: 1;
          opacity: 0;
          transition: opacity 500ms ease-in-out;
        }

        .Overlay--after-open {
          opacity: 1;
        }

        .Overlay--before-close {
          opacity: 0;
        }
      `}
    />
  );
};

export default Modal;
